import React, { useState, useEffect } from 'react';
import Header from '../components/HeaderBar'; // Changed import path for Header
import NutritionReports from './NutritionReports'; // Assuming NutritionReports.jsx is in the same directory
import Reports from './Reports'; // Assuming Reports.jsx is in the same directory
import Tables from './Tables'; // Assuming Tables.jsx is in the same directory
import BIDP from './BIDP'; // Assuming BIDP.jsx is in the same directory
import AdministrativeReports from './AdministrativeReports'; // Assuming AdministrativeReports.jsx is in the same directory
import IDsystem from './IDsystem'; // Import the new IDsystem component
import { useNavigate } from 'react-router-dom';
import localforage from 'localforage';

function MainReportsDashboard() {
  let userRole = parseInt(localStorage.getItem("userRole"), 10);
  const navigate = useNavigate()
  // useEffect(() => {
  //   userRole = parseInt(localStorage.getItem("userRole"), 10);
  //   // Redirect if the user role is not 1
  //   if (userRole !== 1) {
  //     navigate('/');
  //   }
  // }, [navigate]);
  const barangayCode = localStorage.getItem('barangayCode');
  // const barangayCode = '10974'
  const municipalCode = localStorage.getItem('municipalCode');
  // const municipalCode = '422';
  const provincialCode = localStorage.getItem('provincialCode');
  // const provincialCode = '19';
  // State to manage which component is currently active
  const [activeComponent, setActiveComponent] = useState('NutritionReports'); // Default to NutritionReports

  // State for the centralized search functionality
  const [searchQuery, setSearchQuery] = useState(''); // This will now represent the selected barangay name for display
  const [isSearchApplied, setIsSearchApplied] = useState(false);
  // NEW STATE: To store the location data that has been 'applied'
  const [appliedLocationData, setAppliedLocationData] = useState({});

  // New states for dropdown selections and options
  const [provinces, setProvinces] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState({});
  const [municipals, setMunicipals] = useState([]);
  const [selectedMunicipal, setSelectedMunicipal] = useState({});
  const [barangays, setBarangays] = useState([]);
  const [selectedBarangay, setSelectedBarangay] = useState({});

  const provincialItemLookupUsingProvincialCode = async (provincesData, code) => {
    const provinceItem = provincesData.data.find(p => p.province_id === parseInt(code));
    setSelectedProvince(provinceItem);
  }

  const provincialItemLookupUsingMunicipalCode = async (provincesData, code) => {
    const municipalitiesData = await localforage.getItem('location_municipality');
    const provinceContainer = municipalitiesData.data.find(mun => mun.municipalities.find(m => m.municipality_id === parseInt(code)));
    const provinceId = provinceContainer.municipalities.find(m => m.municipality_id === parseInt(code)).province_id;

    provincialItemLookupUsingProvincialCode(provincesData, provinceId);
  }

  const provincialItemLookupUsingBarangayCode = async (provincesData) => {
    const barangaysData = await localforage.getItem('location_barangay');
    const municipalityContainer = barangaysData.data.find(bar => bar.barangays.find(b => b.barangay_id === parseInt(barangayCode)));
    const municipalityId = municipalityContainer.barangays.find(b => b.barangay_id === parseInt(barangayCode)).municipality_id;

    provincialItemLookupUsingMunicipalCode(provincesData, municipalityId);
  }

  const municipalItemLookupUsingMunicipalCode = async (municipalitiesData, code) => {
    const provinceContainer = municipalitiesData.data.find(mun => mun.municipalities.find(m => m.municipality_id === parseInt(code)));
    const municipalityItem = provinceContainer.municipalities.find(m => m.municipality_id === parseInt(code));
    setSelectedMunicipal(municipalityItem);
  }

  const municipalItemLookupUsingBarangayCode = async (municipalitiesData) => {
    const barangaysData = await localforage.getItem('location_barangay');
    const municipalityContainer = barangaysData.data.find(bar => bar.barangays.find(b => b.barangay_id === parseInt(barangayCode)));
    const barangayItem = municipalityContainer.barangays.find(b => b.barangay_id === parseInt(barangayCode));
    const municipalityId = barangayItem.municipality_id;
    setSelectedBarangay(barangayItem);
    municipalItemLookupUsingMunicipalCode(municipalitiesData, municipalityId);
  }

  const barangayItemLookupUsingBarangayCode = async (barangaysData) => {
    const barangayContainer = barangaysData.data.find(bar => bar.barangays.find(b => b.barangay_id === parseInt(barangayCode)));
    const barangayItem = barangayContainer.barangays.find(b => b.barangay_id === parseInt(barangayCode));
    setSelectedBarangay(barangayItem);
  }

  // Fetch provinces 
  useEffect(() => {
      const fetchProvinces = async () => {
          const cacheProvinceKey = 'location_province';
          try {
              const data = await localforage.getItem(cacheProvinceKey)
              setProvinces(data.data);
              if (parseInt(userRole) === 2 && provincialCode) {
                provincialItemLookupUsingProvincialCode(data, provincialCode)
              } else if (parseInt(userRole) === 3 && municipalCode) {
                provincialItemLookupUsingMunicipalCode(data, municipalCode)
              } else if ((parseInt(userRole) === 4 || parseInt(userRole) === 5) && barangayCode) {
                provincialItemLookupUsingBarangayCode(data);
              } else {
                setSelectedProvince({}); // Reset province when region changes
              }
              setMunicipals([]);       // Clear municipals
              setSelectedMunicipal({}); // Reset municipal
              setBarangays([]);         // Clear barangays
              setSelectedBarangay({});  // Reset barangay
          } catch (error) {
              console.error('Error fetching provinces:', error);
          }
      };
      fetchProvinces();
  }, []);

  // Fetch municipals (cities-municipalities) when a province is selected
  useEffect(() => {
      if (selectedProvince) {
          const cacheMunicipalityKey = 'location_municipality';
          const fetchMunicipals = async () => {
              try {
                  const data = await localforage.getItem(cacheMunicipalityKey);
                  const filteredData = Array.isArray(data.data) && selectedProvince
                  ? data.data.find(item => item.province_id === Number(selectedProvince ? selectedProvince.province_id : 0))?.municipalities
                  : [];
                  setMunicipals(filteredData); // Using unfiltered data for simplicity
                  if (parseInt(userRole) === 3 && municipalCode) {
                    municipalItemLookupUsingMunicipalCode(data, municipalCode);
                  } else if ((parseInt(userRole) === 4 || parseInt(userRole) === 5) && barangayCode) {
                    municipalItemLookupUsingBarangayCode(data);
                  } else {
                    setSelectedMunicipal({}); // Reset municipal when province changes
                  }
                  setBarangays([]);         // Clear barangays
                  setSelectedBarangay({});  // Reset barangay
              } catch (error) {
                  console.error('Error fetching municipals:', error);
              }
          }
          fetchMunicipals();
      } else {
          setMunicipals([]);
          setSelectedMunicipal({});
          setBarangays([]);
          setSelectedBarangay({});
      }
  }, [selectedProvince, provinces]);

  // Fetch barangays when a municipal (or city) is selected
  useEffect(() => {
      if (selectedMunicipal) {
          const cacheBarangayKey = 'location_barangay';
          const fetchBarangays = async () => {
              const data = await localforage.getItem(cacheBarangayKey);
              const filteredData = Array.isArray(data.data) && selectedMunicipal
              ? data.data.find(item => item.municipality_id === Number(selectedMunicipal?.municipality_id || 0))?.barangays
              : [];
              setBarangays(filteredData);
              if ((parseInt(userRole) === 4 || parseInt(userRole) === 5) && barangayCode) {
                barangayItemLookupUsingBarangayCode(data);
              } else {
                setSelectedBarangay({}); // Reset barangay when municipal changes
              }
          };
          fetchBarangays();
      } else {
          setBarangays([]);
          setSelectedBarangay({});
      }
  }, [selectedMunicipal, municipals]);

  // Function to handle the centralized "Apply Search" button click
  const handleApplySearch = async () => {
    if (selectedProvince?.province_name?.trim()) {
        setIsSearchApplied(true);
        setSearchQuery(selectedBarangay.barangay_name);

        const locationData = {
            regionName: '',
            provinceName: selectedProvince?.province_name || '',
            municipalName: selectedMunicipal?.municipality_name || '',
            barangayName: selectedBarangay?.barangay_name || '',
        };

        console.log(locationData);

        setAppliedLocationData(locationData);
    } else {
        alert('Please select location.');
        setIsSearchApplied(false);
        setSearchQuery('');
        setAppliedLocationData({});
    }
  };

  // Function to render the active component based on state
  const renderActiveComponent = () => {
    // These props will be passed to each child component
    const commonProps = { searchQuery, isSearchApplied };

    switch (activeComponent) {
      case 'NutritionReports':
        return <NutritionReports {...commonProps} locationData={appliedLocationData} />;
      case 'Reports':
        return <Reports {...commonProps} locationData={appliedLocationData} />;
      case 'Tables':
        return <Tables {...commonProps} locationData={appliedLocationData} />;
      case 'BIDP':
        return <BIDP {...commonProps} locationData={appliedLocationData} />;
      case 'AdministrativeReports':
        // Pass the appliedLocationData to AdministrativeReports
        return <AdministrativeReports {...commonProps} locationData={appliedLocationData} />;
      case 'IDsystem': // New case for IDsystem
        return <IDsystem {...commonProps} locationData={appliedLocationData}/>;
      default:
        return <NutritionReports {...commonProps} locationData={appliedLocationData} />; // Fallback
    }
  };

  return (
    <div style={pageContainer}>
      <Header />
      <div style={dashboardContainer}>
        <h2 style={heading}>Select a Report Category</h2>

        {/* Centralized Search Functionality */}
        <div style={{ marginBottom: '20px', textAlign: 'center' }}>
          <label htmlFor="dashboardSearchInput" style={{ marginRight: '10px', fontSize: '16px', fontWeight: 'bold' }}>Location:</label>

          {/* Province Dropdown */}
          <select
            value={selectedProvince?.province_id || "Select Province"}
            onChange={(e) => {
                const provinceId = e.target.value;
                const selected = provinces.find(p => p.province_id === Number(provinceId));
                setSelectedProvince(selected ? selected : {});
            }}
            disabled={parseInt(userRole) !== 1}
            style={dropdownStyle}
          >
            <option value={0}>Select Province</option>
            {Array.isArray(provinces) && provinces.length > 0 && provinces.map((province) => (
              <option key={province.province_id} value={province.province_id}>
                {province.province_name}
              </option>
            ))}
          </select>

          {/* Municipal Dropdown */}
          <select
            value={Object.keys(selectedMunicipal).length !== 0 ? selectedMunicipal.municipality_id : "Select Municipality"}
            onChange={(e) => {
                const municipalityId = e.target.value;
                const selected = municipals.find(m => m.municipality_id === Number(municipalityId));
                setSelectedMunicipal(selected ? selected : {})
            }}
            style={dropdownStyle}
            disabled={Object.keys(selectedProvince).length === 0 || (parseInt(userRole) !== 1 && parseInt(userRole) !== 2)}
          >
            <option value={0}>Select Municipal</option>
            {Array.isArray(municipals) && municipals.length > 0 && municipals.map((municipal) => (
              <option key={municipal.municipality_id} value={municipal.municipality_id}>
                {municipal.municipality_name}
              </option>
            ))}
          </select>

          {/* Barangay Dropdown */}
          <select
            value={Object.keys(selectedBarangay).length !== 0 ? selectedBarangay.barangay_id : "Select Barangay"}
            onChange={(e) => {
              const barangayId = e.target.value;
              const selected = barangays.find(b => b.barangay_id === Number(barangayId));
              setSelectedBarangay(selected ? selected : {});
              // If user clears the search query after it was applied, reset the applied state
            //   if (isSearchApplied && e.target.value.trim() === '') {
            //     setIsSearchApplied(false);
            //     setSearchQuery('');
            //     setAppliedLocationData({}); // Clear applied location data
            //   }
            }}
            style={dropdownStyle}
            disabled={Object.keys(selectedProvince).length === 0 || (parseInt(userRole) !== 1 && parseInt(userRole) !== 2 && parseInt(userRole) !== 3)}
          >
            <option value={0}>Select Barangay</option>
            {Array.isArray(barangays) && barangays.length > 0 && barangays.map((barangay) => (
              <option key={barangay.barangay_id} value={barangay.barangay_id}>
                {barangay.barangay_name}
              </option>
            ))}
          </select>

          <button
            onClick={handleApplySearch}
            style={{ ...buttonStyle, marginLeft: '10px', padding: '8px 15px', fontSize: '16px' }}
          >
            Apply Search
          </button>
        </div>

        {/* Tab Navigation */}
        <div style={tabContainer}>
          <button
            style={activeComponent === 'NutritionReports' ? activeTabButton : tabButton}
            onClick={() => setActiveComponent('NutritionReports')}
          >
            Nutrition Reports
          </button>
          <button
            style={activeComponent === 'Reports' ? activeTabButton : tabButton}
            onClick={() => setActiveComponent('Reports')}
          >
            Reports
          </button>
          <button
            style={activeComponent === 'Tables' ? activeTabButton : tabButton}
            onClick={() => setActiveComponent('Tables')}
          >
            Tables
          </button>
          <button
            style={activeComponent === 'BIDP' ? activeTabButton : tabButton}
            onClick={() => setActiveComponent('BIDP')}
          >
            BIDP
          </button>
          <button
            style={activeComponent === 'AdministrativeReports' ? activeTabButton : tabButton}
            onClick={() => setActiveComponent('AdministrativeReports')}
          >
            Administrative Reports
          </button>
          <button
            style={activeComponent === 'IDsystem' ? activeTabButton : tabButton}
            onClick={() => setActiveComponent('IDsystem')}
          >
            ID Card Printer
          </button>
        </div>

        {/* Render the active component */}
        <div style={componentDisplayArea}>
          {renderActiveComponent()}
        </div>
      </div>
    </div>
  );
}

// Styling for the dashboard and tabs
const pageContainer = {
  marginTop: "80px", // To account for the Header
  minHeight: "calc(100vh - 80px)",
  backgroundColor: "#f8f9fa",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
};

const dashboardContainer = {
  width: "90%", // Slightly wider to accommodate tabs
  maxWidth: "1200px", // Max width for larger screens
  backgroundColor: "#ffffff",
  padding: "30px",
  borderRadius: "10px",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  marginTop: "20px",
};

const heading = {
  fontSize: "28px",
  fontWeight: "bold",
  marginBottom: "30px",
  textAlign: "center",
  color: "#333",
};

const tabContainer = {
  display: "flex",
  flexWrap: "wrap", // Allow tabs to wrap on smaller screens
  justifyContent: "center",
  marginBottom: "20px",
  borderBottom: "2px solid #e0e0e0",
  paddingBottom: "5px",
  gap: "10px", // Space between buttons
};

const tabButton = {
  padding: "10px 15px",
  backgroundColor: "#f0f0f0",
  color: "#555",
  border: "none",
  borderRadius: "8px 8px 0 0", // Rounded top corners
  cursor: "pointer",
  fontSize: "16px",
  fontWeight: "bold",
  transition: "background-color 0.3s ease, color 0.3s ease",
  whiteSpace: "nowrap", // Prevent text wrapping inside buttons
  flexShrink: 0, // Prevent shrinking
};

const activeTabButton = {
  ...tabButton,
  backgroundColor: "#007bff",
  color: "#fff",
  borderBottom: "2px solid #007bff", // Highlight active tab
};

const componentDisplayArea = {
  marginTop: "20px",
  // The child components (NutritionReports, Reports, etc.) will manage their own internal layout
};

// Reusing the button style from other components for consistency
const buttonStyle = {
  padding: "10px 20px",
  backgroundColor: "#007bff",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "10px",
  transition: 'background-color 0.3s ease',
};

// New style for dropdowns
const dropdownStyle = {
  padding: '8px',
  borderRadius: '5px',
  border: '1px solid #ccc',
  marginRight: '10px',
  fontSize: '16px',
};


export default MainReportsDashboard;
